import {Typography} from '@mui/material';

import usePayment from '../../../hooks/providers/usePayment';

const HeaderAdminModeIndicator = () => {
  const {isAdmin} = usePayment();

  if (!isAdmin) return null;

  return (
    <Typography fontSize={13.5} color="secondary" sx={{mr: 2.5}}>
      Mode admin activé
    </Typography>
  );
};

export default HeaderAdminModeIndicator;
